import { SHOW_ALERT } from '../constants';

export const showAlert = (variant, message) => ({
  type: SHOW_ALERT,
  message,
  variant,
});
